import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromMenus from '../reducers/menu.reducer';
import * as fromRoot from '../../../store';

// tslint:disable-next-line:max-line-length
export const getMenuState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.menus);

export const getMenuEntities = createSelector(getMenuState, fromMenus.getMenusEntities);

export const getAllMenus = createSelector(getMenuEntities, entities => {
  return Object.keys(entities).map(handle => entities[handle]);
});

export const getMenuLoading = createSelector(getMenuState, fromMenus.getMenuLoading);

export const getMainMenu = createSelector(getMenuEntities, fromRoot.getRouterState, (menus, router) => {
  return menus[router?.state?.params?.['menuHandle'] || 'main-menu'];
});
